interface ISticker {
    businessId: number;
    server: string;
    name: string;
    sceneId: string;
    size?: string;
}

export const staticSceneStickers = {

    // minilabels@ms.com
    // 3: [586361, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    // 4: [586361, 'ida.signage.me', {name: 'sticker', sceneId: 10}],

    // text snippets
    10001: [588423, 'ida.signage.me', {name: 'text', sceneId: 7}],
    10002: [588423, 'ida.signage.me', {name: 'text', sceneId: 9}],
    10003: [588423, 'ida.signage.me', {name: 'text', sceneId: 10}],
    10004: [588423, 'ida.signage.me', {name: 'text', sceneId: 11}],
    10005: [588423, 'ida.signage.me', {name: 'text', sceneId: 12}],
    10006: [588423, 'ida.signage.me', {name: 'text', sceneId: 13}],
    10007: [588423, 'ida.signage.me', {name: 'text', sceneId: 14}],
    10008: [588423, 'ida.signage.me', {name: 'text', sceneId: 15}],
    10009: [588423, 'ida.signage.me', {name: 'text', sceneId: 16}],
    10010: [588423, 'ida.signage.me', {name: 'text', sceneId: 17}],
    10011: [588423, 'ida.signage.me', {name: 'text', sceneId: 18}],
    10012: [588423, 'ida.signage.me', {name: 'text', sceneId: 19}],
    10013: [588423, 'ida.signage.me', {name: 'text', sceneId: 20}],
    10014: [588423, 'ida.signage.me', {name: 'text', sceneId: 21}],
    10015: [588423, 'ida.signage.me', {name: 'text', sceneId: 22}],
    10016: [588423, 'ida.signage.me', {name: 'text', sceneId: 23}],
    10017: [588423, 'ida.signage.me', {name: 'text', sceneId: 24}],
    10018: [588423, 'ida.signage.me', {name: 'text', sceneId: 25}],
    10019: [588423, 'ida.signage.me', {name: 'text', sceneId: 26}],
    10020: [588423, 'ida.signage.me', {name: 'text', sceneId: 27}],
    10021: [588423, 'ida.signage.me', {name: 'text', sceneId: 28}],
    10022: [588423, 'ida.signage.me', {name: 'text', sceneId: 29}],
    10023: [588423, 'ida.signage.me', {name: 'text', sceneId: 30}],
    10024: [588423, 'ida.signage.me', {name: 'text', sceneId: 31}],
    10025: [588423, 'ida.signage.me', {name: 'text', sceneId: 32}],
    10026: [588423, 'ida.signage.me', {name: 'text', sceneId: 33}],
    10027: [588423, 'ida.signage.me', {name: 'text', sceneId: 34}],
    10028: [588423, 'ida.signage.me', {name: 'text', sceneId: 35}],
    10029: [588423, 'ida.signage.me', {name: 'text', sceneId: 36}],
    10030: [588423, 'ida.signage.me', {name: 'text', sceneId: 37}],
    10031: [588423, 'ida.signage.me', {name: 'text', sceneId: 38}],
    10032: [588423, 'ida.signage.me', {name: 'text', sceneId: 39}],
    10033: [588423, 'ida.signage.me', {name: 'text', sceneId: 40}],
    10034: [588423, 'ida.signage.me', {name: 'text', sceneId: 41}],
    10035: [588423, 'ida.signage.me', {name: 'text', sceneId: 42}],
    10036: [588423, 'ida.signage.me', {name: 'text', sceneId: 43}],
    10037: [588423, 'ida.signage.me', {name: 'text', sceneId: 44}],
    10038: [588423, 'ida.signage.me', {name: 'text', sceneId: 45}],
    10039: [588423, 'ida.signage.me', {name: 'text', sceneId: 46}],
    // 10040: [588423, 'ida.signage.me', {name: 'text', sceneId: 47}],
    10041: [588423, 'ida.signage.me', {name: 'text', sceneId: 48}],
    10042: [588423, 'ida.signage.me', {name: 'text', sceneId: 49}],
    10043: [588423, 'ida.signage.me', {name: 'text', sceneId: 50}],
    10044: [588423, 'ida.signage.me', {name: 'text', sceneId: 51}],
    10045: [588423, 'ida.signage.me', {name: 'text', sceneId: 52}],
    10046: [588423, 'ida.signage.me', {name: 'text', sceneId: 53}],
    10047: [588423, 'ida.signage.me', {name: 'text', sceneId: 54}],
    10048: [588423, 'ida.signage.me', {name: 'text', sceneId: 55}],
    10049: [588423, 'ida.signage.me', {name: 'text', sceneId: 56}],
    10050: [588423, 'ida.signage.me', {name: 'text', sceneId: 57}],
    10051: [588423, 'ida.signage.me', {name: 'text', sceneId: 58}],
    10052: [588423, 'ida.signage.me', {name: 'text', sceneId: 59}],
    10053: [588423, 'ida.signage.me', {name: 'text', sceneId: 60}],
    10054: [588423, 'ida.signage.me', {name: 'text', sceneId: 61}],
    10055: [588423, 'ida.signage.me', {name: 'text', sceneId: 62}],
    10056: [588423, 'ida.signage.me', {name: 'text', sceneId: 63}],
    10057: [588423, 'ida.signage.me', {name: 'text', sceneId: 64}],
    10058: [588423, 'ida.signage.me', {name: 'text', sceneId: 65}],
    10059: [588423, 'ida.signage.me', {name: 'text', sceneId: 66}],
    10060: [588423, 'ida.signage.me', {name: 'text', sceneId: 67}],
    10061: [588423, 'ida.signage.me', {name: 'text', sceneId: 68}],
    10062: [588423, 'ida.signage.me', {name: 'text', sceneId: 69}],
    10063: [588423, 'ida.signage.me', {name: 'text', sceneId: 70}],
    10064: [588423, 'ida.signage.me', {name: 'text', sceneId: 71}],
    10065: [588423, 'ida.signage.me', {name: 'text', sceneId: 72}],
    10066: [588423, 'ida.signage.me', {name: 'text', sceneId: 73}],
    10067: [588423, 'ida.signage.me', {name: 'text', sceneId: 74}],
    10068: [588423, 'ida.signage.me', {name: 'text', sceneId: 75}],
    10069: [588423, 'ida.signage.me', {name: 'text', sceneId: 76}],
    10070: [588423, 'ida.signage.me', {name: 'text', sceneId: 77}],
    10071: [588423, 'ida.signage.me', {name: 'text', sceneId: 72}],
    10072: [588423, 'ida.signage.me', {name: 'text', sceneId: 78}],
    10073: [588423, 'ida.signage.me', {name: 'text', sceneId: 79}],
    10074: [588423, 'ida.signage.me', {name: 'text', sceneId: 80}],
    10075: [588423, 'ida.signage.me', {name: 'text', sceneId: 81}],
    10076: [588423, 'ida.signage.me', {name: 'text', sceneId: 83}],
    10077: [588423, 'ida.signage.me', {name: 'text', sceneId: 83}],
    10078: [588423, 'ida.signage.me', {name: 'text', sceneId: 84}],
    10079: [588423, 'ida.signage.me', {name: 'text', sceneId: 85}],
    10080: [588423, 'ida.signage.me', {name: 'text', sceneId: 86}],
    10081: [588423, 'ida.signage.me', {name: 'text', sceneId: 87}],
    10082: [588423, 'ida.signage.me', {name: 'text', sceneId: 88}],
    10083: [588423, 'ida.signage.me', {name: 'text', sceneId: 89}],
    10084: [588423, 'ida.signage.me', {name: 'text', sceneId: 90}],
    10085: [588423, 'ida.signage.me', {name: 'text', sceneId: 91}],
    10086: [588423, 'ida.signage.me', {name: 'text', sceneId: 92}],
    10087: [588423, 'ida.signage.me', {name: 'text', sceneId: 93}],
    10088: [588423, 'ida.signage.me', {name: 'text', sceneId: 94}],
    10089: [588423, 'ida.signage.me', {name: 'text', sceneId: 95}],
    10090: [588423, 'ida.signage.me', {name: 'text', sceneId: 96}],
    10091: [588423, 'ida.signage.me', {name: 'text', sceneId: 97}],
    10092: [588423, 'ida.signage.me', {name: 'text', sceneId: 98}],
    10093: [588423, 'ida.signage.me', {name: 'text', sceneId: 99}],
    10094: [588423, 'ida.signage.me', {name: 'text', sceneId: 100}],
    10095: [588423, 'ida.signage.me', {name: 'text', sceneId: 101}],
    10096: [588423, 'ida.signage.me', {name: 'text', sceneId: 102}],
    10097: [588423, 'ida.signage.me', {name: 'text', sceneId: 103}],
    10098: [588423, 'ida.signage.me', {name: 'text', sceneId: 104}],
    10099: [588423, 'ida.signage.me', {name: 'text', sceneId: 105}],
    10100: [588423, 'ida.signage.me', {name: 'text', sceneId: 106}],
    10101: [588423, 'ida.signage.me', {name: 'text', sceneId: 107}],
    10102: [588423, 'ida.signage.me', {name: 'text', sceneId: 108}],
    10103: [588423, 'ida.signage.me', {name: 'text', sceneId: 109}],
    10104: [588423, 'ida.signage.me', {name: 'text', sceneId: 110}],
    10105: [588423, 'ida.signage.me', {name: 'text', sceneId: 111}],
    10106: [588423, 'ida.signage.me', {name: 'text', sceneId: 112}],
    10107: [588423, 'ida.signage.me', {name: 'text', sceneId: 113}],
    10108: [588423, 'ida.signage.me', {name: 'text', sceneId: 114}],
    10109: [588423, 'ida.signage.me', {name: 'text', sceneId: 115}],
    10110: [588423, 'ida.signage.me', {name: 'text', sceneId: 116}],
    10111: [588423, 'ida.signage.me', {name: 'text', sceneId: 117}],
    10112: [588423, 'ida.signage.me', {name: 'text', sceneId: 118}],
    10113: [588423, 'ida.signage.me', {name: 'text', sceneId: 119}],
    10114: [588423, 'ida.signage.me', {name: 'text', sceneId: 120}],
    10115: [588423, 'ida.signage.me', {name: 'text', sceneId: 121}],
    10116: [588423, 'ida.signage.me', {name: 'text', sceneId: 123}],
    10117: [588423, 'ida.signage.me', {name: 'text', sceneId: 124}],
    10118: [588423, 'ida.signage.me', {name: 'text', sceneId: 125}],
    10119: [588423, 'ida.signage.me', {name: 'text', sceneId: 126}],
    10120: [588423, 'ida.signage.me', {name: 'text', sceneId: 127}],
    10121: [588423, 'ida.signage.me', {name: 'text', sceneId: 128}],
    10122: [588423, 'ida.signage.me', {name: 'text', sceneId: 129}],
    10123: [588423, 'ida.signage.me', {name: 'text', sceneId: 130}],
    10124: [588423, 'ida.signage.me', {name: 'text', sceneId: 131}],
    10125: [588423, 'ida.signage.me', {name: 'text', sceneId: 132}],
    10126: [588423, 'ida.signage.me', {name: 'text', sceneId: 133}],
    10127: [588423, 'ida.signage.me', {name: 'text', sceneId: 134}],
    10128: [588423, 'ida.signage.me', {name: 'text', sceneId: 135}],
    10129: [588423, 'ida.signage.me', {name: 'text', sceneId: 136}],
    10130: [588423, 'ida.signage.me', {name: 'text', sceneId: 137}],
    10131: [588423, 'ida.signage.me', {name: 'text', sceneId: 138}],
    10132: [588423, 'ida.signage.me', {name: 'text', sceneId: 139}],
    10133: [588423, 'ida.signage.me', {name: 'text', sceneId: 140}],
    10134: [588423, 'ida.signage.me', {name: 'text', sceneId: 141}],
    10135: [588423, 'ida.signage.me', {name: 'text', sceneId: 142}],
    10136: [588423, 'ida.signage.me', {name: 'text', sceneId: 143}],
    10137: [588423, 'ida.signage.me', {name: 'text', sceneId: 144}],
    10138: [588423, 'ida.signage.me', {name: 'text', sceneId: 145}],
    10139: [588423, 'ida.signage.me', {name: 'text', sceneId: 146}],
    10140: [588423, 'ida.signage.me', {name: 'text', sceneId: 147}],
    10141: [588423, 'ida.signage.me', {name: 'text', sceneId: 148}],
    10142: [588423, 'ida.signage.me', {name: 'text', sceneId: 149}],
    10143: [588423, 'ida.signage.me', {name: 'text', sceneId: 150}],
    10144: [588423, 'ida.signage.me', {name: 'text', sceneId: 151}],
    10145: [588423, 'ida.signage.me', {name: 'text', sceneId: 152}],
    10146: [588423, 'ida.signage.me', {name: 'text', sceneId: 153}],
    10147: [588423, 'ida.signage.me', {name: 'text', sceneId: 154}],
    10148: [588423, 'ida.signage.me', {name: 'text', sceneId: 155}],
    10149: [588423, 'ida.signage.me', {name: 'text', sceneId: 156}],
    10150: [588423, 'ida.signage.me', {name: 'text', sceneId: 158}],
    10151: [588423, 'ida.signage.me', {name: 'text', sceneId: 159}],
    10152: [588423, 'ida.signage.me', {name: 'text', sceneId: 160}],
    10153: [588423, 'ida.signage.me', {name: 'text', sceneId: 161}],
    10154: [588423, 'ida.signage.me', {name: 'text', sceneId: 162}],
    10155: [588423, 'ida.signage.me', {name: 'text', sceneId: 163}],
    10156: [588423, 'ida.signage.me', {name: 'text', sceneId: 164}],
    10157: [588423, 'ida.signage.me', {name: 'text', sceneId: 165}],
    10158: [588423, 'ida.signage.me', {name: 'text', sceneId: 166}],
    10159: [588423, 'ida.signage.me', {name: 'text', sceneId: 167}],
    10160: [588423, 'ida.signage.me', {name: 'text', sceneId: 168}],
    10163: [588423, 'ida.signage.me', {name: 'text', sceneId: 171}],
    10164: [588423, 'ida.signage.me', {name: 'text', sceneId: 172}],
    10165: [588423, 'ida.signage.me', {name: 'text', sceneId: 173}],
    10166: [588423, 'ida.signage.me', {name: 'text', sceneId: 174}],
    10167: [588423, 'ida.signage.me', {name: 'text', sceneId: 175}],
    10168: [588423, 'ida.signage.me', {name: 'text', sceneId: 176}],
    10169: [588423, 'ida.signage.me', {name: 'text', sceneId: 177}],
    10170: [588423, 'ida.signage.me', {name: 'text', sceneId: 178}],
    10171: [588423, 'ida.signage.me', {name: 'text', sceneId: 179}],
    10172: [588423, 'ida.signage.me', {name: 'text', sceneId: 180}],
    10173: [588423, 'ida.signage.me', {name: 'text', sceneId: 181}],
    10174: [588423, 'ida.signage.me', {name: 'text', sceneId: 182}],
    10175: [588423, 'ida.signage.me', {name: 'text', sceneId: 183}],
    10176: [588423, 'ida.signage.me', {name: 'text', sceneId: 184}],
    10177: [588423, 'ida.signage.me', {name: 'text', sceneId: 185}],
    10178: [588423, 'ida.signage.me', {name: 'text', sceneId: 186}],
    10179: [588423, 'ida.signage.me', {name: 'text', sceneId: 187}],
    10180: [588423, 'ida.signage.me', {name: 'text', sceneId: 188}],
    10181: [588423, 'ida.signage.me', {name: 'text', sceneId: 189}],
    10182: [588423, 'ida.signage.me', {name: 'text', sceneId: 190}],
    10183: [588423, 'ida.signage.me', {name: 'text', sceneId: 191}],
    10184: [588423, 'ida.signage.me', {name: 'text', sceneId: 192}],
    10185: [588423, 'ida.signage.me', {name: 'text', sceneId: 193}],
    10186: [588423, 'ida.signage.me', {name: 'text', sceneId: 194}],
    10187: [588423, 'ida.signage.me', {name: 'text', sceneId: 195}],
    10188: [588423, 'ida.signage.me', {name: 'text', sceneId: 196}],
    10189: [588423, 'ida.signage.me', {name: 'text', sceneId: 197}],
    10190: [588423, 'ida.signage.me', {name: 'text', sceneId: 198}],
    10191: [588423, 'ida.signage.me', {name: 'text', sceneId: 199}],
    10192: [588423, 'ida.signage.me', {name: 'text', sceneId: 200}],
    10193: [588423, 'ida.signage.me', {name: 'text', sceneId: 201}],
    10194: [588423, 'ida.signage.me', {name: 'text', sceneId: 202}],
    10195: [588423, 'ida.signage.me', {name: 'text', sceneId: 203}],
    10196: [588423, 'ida.signage.me', {name: 'text', sceneId: 204}],
    10197: [588423, 'ida.signage.me', {name: 'text', sceneId: 205}],
    10198: [588423, 'ida.signage.me', {name: 'text', sceneId: 206}],
    10199: [588423, 'ida.signage.me', {name: 'text', sceneId: 207}],
    101100: [588423, 'ida.signage.me', {name: 'text', sceneId: 208}],
    101101: [588423, 'ida.signage.me', {name: 'text', sceneId: 209}],
    101200: [588423, 'ida.signage.me', {name: 'text', sceneId: 212}],
    101201: [588423, 'ida.signage.me', {name: 'text', sceneId: 213}],
    101202: [588423, 'ida.signage.me', {name: 'text', sceneId: 214}],
    101203: [588423, 'ida.signage.me', {name: 'text', sceneId: 215}],
    101204: [588423, 'ida.signage.me', {name: 'text', sceneId: 216}],
    101205: [588423, 'ida.signage.me', {name: 'text', sceneId: 217}],
    101206: [588423, 'ida.signage.me', {name: 'text', sceneId: 218}],
    101207: [588423, 'ida.signage.me', {name: 'text', sceneId: 219}],
    101208: [588423, 'ida.signage.me', {name: 'text', sceneId: 220}],
    101209: [588423, 'ida.signage.me', {name: 'text', sceneId: 221}],
    101210: [588423, 'ida.signage.me', {name: 'text', sceneId: 222}],
    101211: [588423, 'ida.signage.me', {name: 'text', sceneId: 223}],
    101212: [588423, 'ida.signage.me', {name: 'text', sceneId: 224}],
    101213: [588423, 'ida.signage.me', {name: 'text', sceneId: 225}],
    101214: [588423, 'ida.signage.me', {name: 'text', sceneId: 226}],
    101215: [588423, 'ida.signage.me', {name: 'text', sceneId: 227}],
    101216: [588423, 'ida.signage.me', {name: 'text', sceneId: 228}],
    101217: [588423, 'ida.signage.me', {name: 'text', sceneId: 229}],
    101218: [588423, 'ida.signage.me', {name: 'text', sceneId: 230}],
    101219: [588423, 'ida.signage.me', {name: 'text', sceneId: 231}],
    101220: [588423, 'ida.signage.me', {name: 'text', sceneId: 232}],
    101221: [588423, 'ida.signage.me', {name: 'text', sceneId: 233}],
    101222: [588423, 'ida.signage.me', {name: 'text', sceneId: 234}],
    101223: [588423, 'ida.signage.me', {name: 'text', sceneId: 235}],
    101224: [588423, 'ida.signage.me', {name: 'text', sceneId: 236}],
    101225: [588423, 'ida.signage.me', {name: 'text', sceneId: 237}],
    101226: [588423, 'ida.signage.me', {name: 'text', sceneId: 238}],
    101227: [588423, 'ida.signage.me', {name: 'text', sceneId: 239}],
    101228: [588423, 'ida.signage.me', {name: 'text', sceneId: 240}],
    101229: [588423, 'ida.signage.me', {name: 'text', sceneId: 241}],
    101230: [588423, 'ida.signage.me', {name: 'text', sceneId: 242}],
    101231: [588423, 'ida.signage.me', {name: 'text', sceneId: 243}],
    101232: [588423, 'ida.signage.me', {name: 'text', sceneId: 244}],
    101233: [588423, 'ida.signage.me', {name: 'text', sceneId: 245}],
    101234: [588423, 'ida.signage.me', {name: 'text', sceneId: 246}],
    101235: [588423, 'ida.signage.me', {name: 'text', sceneId: 247}],
    101236: [588423, 'ida.signage.me', {name: 'text', sceneId: 248}],
    101237: [588423, 'ida.signage.me', {name: 'text', sceneId: 249}],
    101238: [588423, 'ida.signage.me', {name: 'text', sceneId: 250}],
    101239: [588423, 'ida.signage.me', {name: 'text', sceneId: 251}],
    101240: [588423, 'ida.signage.me', {name: 'text', sceneId: 252}],
    101241: [588423, 'ida.signage.me', {name: 'text', sceneId: 253}],
    101242: [588423, 'ida.signage.me', {name: 'text', sceneId: 254}],
    101243: [588423, 'ida.signage.me', {name: 'text', sceneId: 255}],
    101244: [588423, 'ida.signage.me', {name: 'text', sceneId: 256}],
    101245: [588423, 'ida.signage.me', {name: 'text', sceneId: 257}],
    101246: [588423, 'ida.signage.me', {name: 'text', sceneId: 258}],
    101247: [588423, 'ida.signage.me', {name: 'text', sceneId: 259}],
    101248: [588423, 'ida.signage.me', {name: 'text', sceneId: 260}],
    101249: [588423, 'ida.signage.me', {name: 'text', sceneId: 261}],
    101250: [588423, 'ida.signage.me', {name: 'text', sceneId: 262}],
    101251: [588423, 'ida.signage.me', {name: 'text', sceneId: 263}],
    101252: [588423, 'ida.signage.me', {name: 'text', sceneId: 264}],
    101253: [588423, 'ida.signage.me', {name: 'text', sceneId: 265}],
    101254: [588423, 'ida.signage.me', {name: 'text', sceneId: 266}],
    101255: [588423, 'ida.signage.me', {name: 'text', sceneId: 267}],
    101256: [588423, 'ida.signage.me', {name: 'text', sceneId: 268}],
    101257: [588423, 'ida.signage.me', {name: 'text', sceneId: 269}],
    101258: [588423, 'ida.signage.me', {name: 'text', sceneId: 270}],
    101259: [588423, 'ida.signage.me', {name: 'text', sceneId: 271}],
    101260: [588423, 'ida.signage.me', {name: 'text', sceneId: 272}],
    101261: [588423, 'ida.signage.me', {name: 'text', sceneId: 273}],
    101262: [588423, 'ida.signage.me', {name: 'text', sceneId: 274}],
    101263: [588423, 'ida.signage.me', {name: 'text', sceneId: 275}],
    101264: [588423, 'ida.signage.me', {name: 'text', sceneId: 276}],
    101265: [588423, 'ida.signage.me', {name: 'text', sceneId: 277}],
    101266: [588423, 'ida.signage.me', {name: 'text', sceneId: 278}],
    101267: [588423, 'ida.signage.me', {name: 'text', sceneId: 279}],
    101268: [588423, 'ida.signage.me', {name: 'text', sceneId: 280}],
    101269: [588423, 'ida.signage.me', {name: 'text', sceneId: 281}],
    101270: [588423, 'ida.signage.me', {name: 'text', sceneId: 282}],
    101271: [588423, 'ida.signage.me', {name: 'text', sceneId: 283}],
    101272: [588423, 'ida.signage.me', {name: 'text', sceneId: 284}],
    101273: [588423, 'ida.signage.me', {name: 'text', sceneId: 285}],
    101274: [588423, 'ida.signage.me', {name: 'text', sceneId: 286}],
    101275: [588423, 'ida.signage.me', {name: 'text', sceneId: 287}],
    101276: [588423, 'ida.signage.me', {name: 'text', sceneId: 288}],
    101277: [588423, 'ida.signage.me', {name: 'text', sceneId: 289}],
    101278: [588423, 'ida.signage.me', {name: 'text', sceneId: 290}],
    101279: [588423, 'ida.signage.me', {name: 'text', sceneId: 291}],
    101280: [588423, 'ida.signage.me', {name: 'text', sceneId: 292}],
    101281: [588423, 'ida.signage.me', {name: 'text', sceneId: 293}],
    101282: [588423, 'ida.signage.me', {name: 'text', sceneId: 294}],
    101283: [588423, 'ida.signage.me', {name: 'text', sceneId: 295}],
    101284: [588423, 'ida.signage.me', {name: 'text', sceneId: 296}],
    101285: [588423, 'ida.signage.me', {name: 'text', sceneId: 297}],
    101286: [588423, 'ida.signage.me', {name: 'text', sceneId: 298}],
    101287: [588423, 'ida.signage.me', {name: 'text', sceneId: 299}],
    101288: [588423, 'ida.signage.me', {name: 'text', sceneId: 300}],
    101289: [588423, 'ida.signage.me', {name: 'text', sceneId: 301}],

    // stickers
    5: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    6: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    7: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    8: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    9: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    10: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    11: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    12: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    13: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    14: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    15: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    16: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    17: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    18: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    19: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    20: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    21: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    22: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    23: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    24: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    25: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    26: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    27: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    28: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    29: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    30: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    31: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    32: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    33: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    34: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    35: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    36: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    37: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    38: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    39: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    40: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    41: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    42: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    43: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    44: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    45: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    46: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    47: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    48: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    49: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    50: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    51: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    52: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    53: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    54: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    55: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    56: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    57: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    58: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    59: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    60: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    61: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    62: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    63: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    64: [586808, 'ida.signage.me', {name: 'sticker', sceneId: 78}],

    // Oscar
    65: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    66: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    67: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    68: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    69: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    70: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    71: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    72: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    73: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    74: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    75: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    76: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    77: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    78: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    79: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    80: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    81: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    82: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    83: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    84: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    85: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    86: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    87: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    88: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    89: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    90: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    91: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    92: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    93: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    94: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    95: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    96: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    97: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    98: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    99: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    100: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    101: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    102: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    103: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    104: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    105: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    106: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    107: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    108: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    109: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    110: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    111: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    112: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    113: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    114: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    115: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    116: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    117: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    118: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    119: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    120: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    121: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    122: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    123: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    124: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    125: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    126: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    127: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    128: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    129: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    130: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    131: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    132: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    133: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    134: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    135: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    136: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    137: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    138: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    139: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    140: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    141: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    142: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    143: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    144: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    145: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    146: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    147: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    148: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    149: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    150: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    151: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    152: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    153: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    154: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    155: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    156: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    157: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    158: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    159: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 111}],
    160: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 112}],
    161: [587999, 'ida.signage.me', {name: 'sticker', sceneId: 112}],
    162: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    163: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    164: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    165: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    166: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    167: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    168: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    169: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    170: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    171: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    172: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    173: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    174: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    175: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    176: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    177: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    178: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    179: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    180: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    181: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    182: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    183: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    184: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    185: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    186: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    187: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    188: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    189: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    190: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    191: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    192: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    193: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    194: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    195: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    196: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    197: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    198: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    199: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    200: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    201: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    202: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    203: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    204: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    205: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    206: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    207: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    208: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    209: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    210: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    211: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    213: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    214: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    215: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    216: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    217: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    218: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    219: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    220: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    221: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    222: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    223: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    224: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    225: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    226: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    227: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    228: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    229: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    230: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    231: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    232: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    233: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    234: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    235: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    236: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    237: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    238: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    239: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    240: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    241: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    242: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    243: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    244: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    245: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    246: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    247: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    248: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    249: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    250: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    251: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    252: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    253: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    254: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    255: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    256: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    257: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    258: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    259: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    260: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    261: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    262: [588809, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    264: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    265: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    266: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    267: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    268: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    269: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    270: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    271: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    272: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    273: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    274: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    275: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    276: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    277: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    278: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    279: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    280: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    281: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    282: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    283: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    284: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    286: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    287: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    288: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    289: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    290: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    291: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    292: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    293: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    294: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    295: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    296: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    297: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    298: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    299: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    300: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    301: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    302: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    303: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    304: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    305: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    306: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    307: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    308: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    309: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    310: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    311: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    312: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    313: [589255, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    314: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    315: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    316: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    317: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    318: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    319: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    320: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    321: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    322: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    323: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    324: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    325: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    326: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    327: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    328: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    329: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    330: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    331: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    332: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    333: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    334: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    335: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    336: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    337: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    338: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    339: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    340: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    341: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    342: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    343: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    344: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    345: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    346: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    347: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    348: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    349: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    350: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    351: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    352: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    353: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    354: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    355: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    356: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    357: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    358: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    359: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    360: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    361: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    362: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    363: [589738, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    365: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    366: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    367: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    368: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    369: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    370: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    371: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    372: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    373: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    374: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    377: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    378: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    379: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    380: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    381: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    382: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    383: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    384: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    385: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    386: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    387: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    388: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    389: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    390: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    391: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    392: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    393: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    394: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    395: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    396: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    397: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    398: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    399: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    401: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    402: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    404: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    405: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    407: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    408: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    409: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    410: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    411: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    412: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    413: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    414: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    415: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    416: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    417: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    418: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    419: [589826, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    420: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    421: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    422: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    423: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    424: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    425: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    426: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    427: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    428: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    429: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    430: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    431: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    432: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    433: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    434: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    435: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    436: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    437: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    438: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    439: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    440: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    441: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    442: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    443: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    444: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    445: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    446: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    447: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    448: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    449: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    450: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    451: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    452: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    453: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    454: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    455: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    456: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    457: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    458: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    459: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    460: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    461: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    462: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    463: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    464: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    465: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    466: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    467: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    468: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    469: [590105, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    470: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    471: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    472: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    473: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    474: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    475: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    476: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    477: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    478: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    479: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    480: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    481: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    482: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    483: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    484: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    485: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    486: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    487: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    488: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    489: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    490: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    491: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    492: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    493: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    494: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    495: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    496: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    497: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    498: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    499: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    500: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    501: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    502: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    503: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    504: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    505: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    506: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    507: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    508: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    509: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    510: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    511: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    512: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    513: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    514: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    515: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    516: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    517: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    518: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    519: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    520: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    521: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    522: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    523: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    524: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    525: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    526: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    527: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    528: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    529: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    530: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    531: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    532: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    533: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    534: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    535: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    536: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    537: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    538: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    539: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    540: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    541: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    542: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    543: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    544: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    545: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    546: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    547: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    548: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    549: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    550: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    551: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    552: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    553: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    554: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    555: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    556: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    557: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    558: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    559: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    560: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    561: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    562: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    563: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    564: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    565: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    566: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    567: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    568: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    569: [590419, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    570: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    571: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    572: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    573: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    574: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    575: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    576: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    577: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    578: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    579: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    580: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    581: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    582: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    584: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    585: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    586: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    587: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    588: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    589: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    590: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    591: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    592: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    593: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    594: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    595: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    596: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    597: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    598: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    599: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    600: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    601: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    602: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    603: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    604: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    605: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    606: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    607: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    608: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    609: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    610: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    611: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    612: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    613: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    614: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    615: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    616: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    617: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    618: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    619: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    620: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    621: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    622: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    623: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    624: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    625: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    626: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    627: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    628: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    629: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    630: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    631: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    632: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    633: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    634: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    635: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    636: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    637: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    638: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    639: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    640: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    641: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    642: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    643: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    644: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    645: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    646: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    647: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    648: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    649: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    650: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    651: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    652: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    653: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    654: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    655: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    656: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    657: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    658: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    659: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    660: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    661: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    662: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    663: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    664: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    665: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    666: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    667: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    668: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    669: [590603, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    670: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    // 671: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    672: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    673: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    674: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    675: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    676: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    677: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    678: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    679: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    680: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    681: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    682: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    683: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    684: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    685: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    686: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    687: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    688: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    689: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    690: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    691: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    692: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    693: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    694: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    695: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    696: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    697: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    698: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    699: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    700: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    701: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    702: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    703: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    704: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    705: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    706: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    707: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    708: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    709: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    710: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    711: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    712: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    713: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    714: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    715: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    716: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    717: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    718: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    719: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    720: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    721: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    722: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    723: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    724: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    725: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    726: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    727: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    728: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    729: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    730: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    731: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    732: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    733: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    734: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    735: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    736: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    737: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    738: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    739: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    740: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    741: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    742: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    743: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    744: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    745: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    746: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    747: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    748: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    749: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    750: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    751: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    752: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    753: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    754: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    755: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    756: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    757: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    758: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    759: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    760: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    761: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    762: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    763: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    764: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    765: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    766: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    767: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    768: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    769: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    770: [590892, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    771: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    772: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    773: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    774: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    775: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    776: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    777: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    778: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    779: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    780: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    781: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    782: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    783: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    784: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    785: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    786: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    787: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    788: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    789: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    790: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    791: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    792: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    793: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    794: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    795: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    796: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    797: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    798: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    799: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    800: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    801: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    802: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    803: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    804: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    805: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    806: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    807: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    808: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    809: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    810: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    811: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    812: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    813: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    814: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    815: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    816: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    817: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    818: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    819: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    820: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    821: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    822: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    823: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    824: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    825: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    826: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    827: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    828: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    829: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    830: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    831: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    832: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    833: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    834: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    835: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    836: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    837: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    838: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    839: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    840: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    841: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    842: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    843: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    844: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    845: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    846: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    847: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    848: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    849: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    850: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    851: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    852: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    853: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    854: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    855: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    856: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    857: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    858: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    859: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    860: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    861: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    862: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    863: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    864: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    865: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    866: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    867: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    868: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    869: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    870: [591192, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    871: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    873: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    874: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    875: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    876: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    877: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    878: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    879: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    880: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    881: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    882: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    883: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    884: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    885: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    886: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    887: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    888: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    889: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    890: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    891: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    892: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    893: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    894: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    895: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    896: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    897: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    898: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    899: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    900: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    901: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    902: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    903: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    904: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    905: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    906: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    907: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    908: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    909: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    910: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    911: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    912: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    913: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    914: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    915: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    916: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    917: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    918: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    919: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    920: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    921: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    922: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    923: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    924: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    925: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    926: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    927: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    928: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    929: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    930: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    931: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    932: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    933: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    934: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    935: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    936: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    937: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    938: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    939: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    940: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    941: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    942: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    943: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    944: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    945: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    946: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    947: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    948: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    949: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    950: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    951: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    952: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    953: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    954: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    955: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    956: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    957: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    958: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    959: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    960: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    961: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    962: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    963: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    964: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    965: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    966: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    967: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    968: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    969: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    970: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    971: [591489, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    972: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    973: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    974: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    975: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    976: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    977: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    978: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    979: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    980: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    981: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    982: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    983: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    984: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    985: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    986: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    987: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    988: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    989: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    990: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    991: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    992: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    993: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    994: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    995: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    996: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    997: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    998: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    999: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1000: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1001: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1002: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1003: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1004: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1005: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1006: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1007: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1008: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1009: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1010: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1011: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1013: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1014: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1015: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1016: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1017: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1019: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1020: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1021: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1022: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1024: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1025: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1026: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1027: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1028: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1029: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1030: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1031: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1032: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1033: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1036: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1038: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1039: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1040: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1041: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1042: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1043: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1044: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1045: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1046: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1047: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1048: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1049: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1050: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1051: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1052: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1053: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1054: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1055: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1056: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1057: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1058: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1059: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1060: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1061: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1062: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1063: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1064: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1065: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1066: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1067: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1068: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1070: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1071: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1072: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1073: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1074: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1075: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1076: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1077: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 111}],
    1078: [591503, 'ida.signage.me', {name: 'sticker', sceneId: 112}],
    1079: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1080: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1081: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1082: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1083: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 111}],
    1084: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 112}],
    1085: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 113}],
    1086: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 114}],
    1090: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 118}],
    1092: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 120}],
    1094: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 122}],
    1098: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 126}],
    1099: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 127}],
    1100: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 128}],
    1101: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 129}],
    1102: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 130}],
    1103: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 131}],
    1104: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 132}],
    1105: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 133}],
    1106: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 134}],
    1107: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 135}],
    1108: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 136}],
    1109: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 137}],
    1110: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 138}],
    1111: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 139}],
    1112: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 140}],
    1113: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 141}],
    1114: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 142}],
    1115: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 143}],
    1116: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 144}],
    1117: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 145}],
    1118: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 146}],
    1119: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 147}],
    1120: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 148}],
    1121: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 149}],
    1122: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 150}],
    1123: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 151}],
    1124: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 152}],
    1125: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 153}],
    1126: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 154}],
    1128: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 156}],
    1129: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 157}],
    1130: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 158}],
    1131: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 159}],
    1132: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 160}],
    1133: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 161}],
    1134: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 162}],
    1135: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 163}],
    1136: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 164}],
    1137: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 165}],
    1140: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 168}],
    1141: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 169}],
    1142: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 170}],
    1143: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 171}],
    1144: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 172}],
    1145: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 173}],
    1146: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 174}],
    1147: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 175}],
    1148: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 176}],
    1149: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 177}],
    1150: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 178}],
    1151: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 179}],
    1152: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 180}],
    1153: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 181}],
    1154: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 182}],
    1155: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 183}],
    1156: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 184}],
    1157: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 185}],
    1158: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 186}],
    1159: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 187}],
    1160: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 188}],
    1161: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 189}],
    1162: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 190}],
    1163: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 191}],
    1164: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 192}],
    1165: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 193}],
    1166: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 194}],
    1167: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 195}],
    1168: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 196}],
    1169: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 197}],
    1170: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 198}],
    1171: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 199}],
    1172: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 200}],
    1173: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 201}],
    1174: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 202}],
    1175: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 203}],
    1176: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 204}],
    1177: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 205}],
    1178: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 206}],
    1179: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1180: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 207}],
    1191: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 217}],
    1192: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 218}],
    1193: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 219}],
    1194: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 220}],
    1195: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 221}],
    1196: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 222}],
    1197: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 223}],
    1198: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 224}],
    1199: [591513, 'ida.signage.me', {name: 'sticker', sceneId: 225}],
    1200: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1201: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    1202: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1203: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    1204: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1205: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    1206: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1207: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1208: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1209: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1210: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1213: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1214: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1215: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1216: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1217: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1218: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1219: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1220: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1221: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1222: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1223: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1224: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1225: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1226: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1227: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1228: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1229: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1230: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1231: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1232: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1233: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1234: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1235: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1236: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1237: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1238: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1239: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1240: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1241: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1242: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1243: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1245: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1246: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1247: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1248: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1249: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1250: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1251: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1252: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1253: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1254: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1255: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1256: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1257: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1258: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1259: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1260: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1261: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1262: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1263: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1264: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1265: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1266: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1267: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1268: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1269: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1270: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1271: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1272: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1273: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1274: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1275: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1276: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1277: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1278: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1279: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1280: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1281: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1282: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1284: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1286: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1287: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1288: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1289: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1290: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1291: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1292: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1293: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1294: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1295: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1296: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1297: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1298: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1299: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1300: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1301: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1302: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1303: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1304: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1305: [591524, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1316: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1336: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1337: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1338: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1339: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1340: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1341: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1342: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1343: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1344: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1345: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1346: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1347: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1348: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1349: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1350: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1351: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1352: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1353: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1354: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1355: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1356: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1357: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1358: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1359: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1360: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1361: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1362: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1363: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1364: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1365: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1366: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1367: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1368: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1369: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1370: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1371: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1372: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1373: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1374: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1375: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1376: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1377: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1378: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1379: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1380: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1381: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1382: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1383: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1384: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1385: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1386: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1387: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1388: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1389: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1390: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1391: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1392: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1393: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1394: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1395: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1396: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1397: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1398: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1399: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1400: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1401: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1402: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1403: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1404: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1405: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1406: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1407: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1408: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1409: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1410: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1411: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 111}],
    1412: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 112}],
    1413: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 113}],
    1414: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 114}],
    1415: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 115}],
    1416: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 116}],
    1417: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 117}],
    1418: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 118}],
    1419: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 119}],
    1420: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 120}],
    1421: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 121}],
    1422: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 122}],
    1423: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 123}],
    1424: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 124}],
    1425: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 125}],
    1426: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 126}],
    1427: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 127}],
    1428: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 128}],
    1429: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 129}],
    1430: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 130}],
    1431: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 131}],
    1433: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 133}],
    1434: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 134}],
    1435: [591682, 'ida.signage.me', {name: 'sticker', sceneId: 135}],
    1436: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1437: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    1438: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1439: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    1440: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1441: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    1442: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1443: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1444: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1445: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1446: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1447: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1448: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1449: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1450: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1451: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1452: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1453: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1454: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1455: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1456: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1457: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1458: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1459: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1460: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1461: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1462: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1463: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1464: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1465: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1466: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1467: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1468: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1469: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1470: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1471: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1472: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1473: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1474: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1475: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1476: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1477: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1478: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1479: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1480: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1481: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1482: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1483: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1484: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1485: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1486: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1487: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1488: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1489: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1490: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1491: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1492: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1493: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1494: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1495: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1496: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1497: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1498: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1499: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1500: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1501: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1502: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1503: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1504: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1505: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1506: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1507: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1508: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1509: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1510: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1511: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1512: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1513: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1514: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1515: [592726, 'ida.signage.me', {name: 'sticker', sceneId: 85}],


    1517: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1518: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1519: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1520: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1521: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1522: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1523: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1524: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1525: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1526: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    1527: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1528: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1529: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1530: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1531: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1532: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1533: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1534: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1535: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1536: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1537: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1538: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1539: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1540: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1541: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1542: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1543: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1544: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1545: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1546: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1547: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1548: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1549: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1550: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1551: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1552: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1553: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1554: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1555: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1556: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1557: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1558: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1559: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1560: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1561: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1562: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1563: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1564: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1565: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1566: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1567: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1568: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1569: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1570: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1571: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1572: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1573: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1574: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1575: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1576: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1577: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1578: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1579: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1580: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1581: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1582: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1583: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1584: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    1585: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1586: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1587: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1588: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1589: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1590: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1591: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1592: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1594: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1595: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1596: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1597: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1598: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1599: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1600: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1601: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1602: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1603: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1604: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1605: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1606: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    1607: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1608: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1609: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1610: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1611: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1612: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1613: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1614: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1615: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1616: [595377, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1617: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1618: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1619: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1620: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1621: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1622: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1623: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1624: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1625: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1626: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1628: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1629: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1630: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1631: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1632: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1633: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1634: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1635: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1636: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1637: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1638: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1639: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1640: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1641: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1642: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1643: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1644: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1645: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1646: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1647: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1648: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1649: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1650: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1651: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1652: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1653: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1654: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1655: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1656: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1657: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1658: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1659: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1660: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1661: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1662: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1663: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1664: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1665: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1666: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1667: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1668: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1669: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1670: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1671: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1672: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1673: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1674: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1675: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1676: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1677: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1678: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1679: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1680: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1681: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1682: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1683: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1684: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1685: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1686: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1687: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1688: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1689: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1690: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1691: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1692: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1693: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1694: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1695: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1696: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1697: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1698: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1699: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1700: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1701: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1702: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1703: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1704: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1705: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1706: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1707: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1708: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1709: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1710: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1711: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1712: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1713: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1714: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1715: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1716: [595387, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1717: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1718: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1720: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1721: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1722: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1723: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1724: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1725: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1726: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1727: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1728: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1729: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1730: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1731: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1732: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1733: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1734: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1735: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1736: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1737: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1738: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1739: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1740: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1741: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1742: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1743: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1744: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1745: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1746: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1747: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1748: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1749: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1750: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1751: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1752: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1753: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1754: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1755: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1756: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1757: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1758: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1759: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1760: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1761: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1762: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1763: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1764: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1765: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1766: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1767: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1768: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1769: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1770: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1771: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1772: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1773: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1774: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1775: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1776: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1777: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1778: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1779: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1780: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1781: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1782: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1783: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1784: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    1785: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1786: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1787: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1788: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1789: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1790: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1791: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1792: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1793: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1794: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1795: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1796: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1797: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1798: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1799: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1800: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1801: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1802: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1803: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1804: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1805: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1806: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    1807: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    1808: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1809: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1810: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1811: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1812: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1813: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1814: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1815: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1816: [595518, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1818: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1819: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1820: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1821: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1822: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1823: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1824: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1825: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1826: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1827: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1828: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1829: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 6}],
    1830: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 7}],
    1831: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1832: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1833: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1834: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1835: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1836: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1837: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1838: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 106}],
    1839: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 107}],
    1840: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 108}],
    1841: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 109}],
    1842: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    1843: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 110}],
    1844: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1845: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1846: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1847: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1848: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1849: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1850: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1851: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1852: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1853: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1854: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1855: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1856: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1857: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1858: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1859: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1860: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1861: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1862: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1863: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1864: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1865: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1866: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1867: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1868: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1869: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1870: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1871: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1872: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1873: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1874: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1875: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1876: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1877: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1878: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1879: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1880: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1881: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1882: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1883: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1884: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1885: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1886: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1887: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1888: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1889: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1890: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1891: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1892: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1893: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1894: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1895: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1896: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1897: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1898: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1899: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1900: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1901: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1902: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    1903: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    1904: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    1905: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    1906: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    1907: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    1908: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    1909: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    1910: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    1911: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    1912: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    1913: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    1914: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    1915: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    1916: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    1917: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    1918: [595621, 'ida.signage.me', {name: 'sticker', sceneId: 99}],
    1919: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 10}],
    1920: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 100}],
    1921: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 101}],
    1922: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 102}],
    1923: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 103}],
    1924: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 104}],
    1925: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 105}],
    1926: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 11}],
    1927: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 12}],
    1928: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 13}],
    1929: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 14}],
    1930: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 15}],
    1931: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 16}],
    1932: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 17}],
    1933: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 18}],
    1934: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 19}],
    1935: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 20}],
    1936: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 21}],
    1937: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 22}],
    1938: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 23}],
    1939: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 24}],
    1940: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 25}],
    1941: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 26}],
    1942: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 27}],
    1943: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 28}],
    1944: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 29}],
    1945: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 30}],
    1946: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 31}],
    1947: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 32}],
    1948: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 33}],
    1949: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 34}],
    1950: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 35}],
    1951: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 36}],
    1952: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 37}],
    1953: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 38}],
    1954: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 39}],
    1955: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 40}],
    1956: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 41}],
    1957: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 42}],
    1958: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 43}],
    1959: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 44}],
    1960: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 45}],
    1961: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 46}],
    1962: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 47}],
    1963: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 48}],
    1964: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 49}],
    1965: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 50}],
    1966: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 51}],
    1967: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 52}],
    1968: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 53}],
    1969: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 54}],
    1970: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 55}],
    1971: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 56}],
    1972: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 57}],
    1973: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 58}],
    1974: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 59}],
    1975: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 60}],
    1976: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 61}],
    1977: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 62}],
    1978: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 63}],
    1979: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 64}],
    1980: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 65}],
    1981: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 66}],
    1982: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 67}],
    1983: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 68}],
    1984: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 69}],
    1985: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 70}],
    1986: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 71}],
    1987: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 72}],
    1988: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 73}],
    1989: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 74}],
    1990: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 75}],
    1991: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 76}],
    1992: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 77}],
    1993: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 78}],
    1994: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 79}],
    1995: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 8}],
    1996: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 80}],
    1997: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 81}],
    1998: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 82}],
    1999: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 83}],
    2000: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 84}],
    2001: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 85}],
    2002: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 86}],
    2003: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 87}],
    2004: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 88}],
    2005: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 89}],
    2006: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 9}],
    2007: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 90}],
    2008: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 91}],
    2009: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 92}],
    2010: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 93}],
    2011: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 94}],
    2012: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 95}],
    2013: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 96}],
    2014: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 97}],
    2015: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 98}],
    2016: [595753, 'ida.signage.me', {name: 'sticker', sceneId: 99}]

};




